module.exports = __webpack_public_path__ + "static/media/logo.f07a1cb4.svg";